import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Heading,
  Text,
  Image,
  SimpleGrid,
  VStack,
  useColorModeValue,
  Flex,
  Badge,Wrap, WrapItem, 
  Icon,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
// import product from "../../../assets/images/glass18.png";
// import sitGLass from "../../../assets/images/glass1.jpg";
// import Glass from "../../../assets/images/glass7.jpg";
// import door from "../../../assets/images/glass3.jpg";
// import doorsmetal from "../../../assets/images/glass19.png";
// import studioglassdoors from "../../../assets/images/glass5.jpg";
// import glass1 from "../../../assets/images/glass1.jpg";
// import glass2 from "../../../assets/images/glass2.jpg";
// import glass3 from "../../../assets/images/glass3.jpg";
// import glass4 from "../../../assets/images/glass4.jpg";
// import glass5 from "../../../assets/images/glass5.jpg";
// import glass6 from "../../../assets/images/glass6.jpg";
import { FiArrowRight } from "react-icons/fi";
import * as Constants from "../../../constants/Constants";

const MotionBox = motion(Box);
const MotionImage = motion(Image);

const ProductDetails = () => {
  const [hoveredId, setHoveredId] = useState(null);
  const cardBg = useColorModeValue("white", "#000000");
  const cardBorder = useColorModeValue("#000000", "#000000");
  // const titleColor = useColorModeValue("black");
  const textColor = useColorModeValue("#000000", "#000000");
  const hoverShadow = useColorModeValue("xl", "dark-lg");
  const [images, setImages] = useState([]);
  useEffect(() => {
          axios
            .get(Constants.REACT_APP_API_URL + "api/upload/product")
            .then((res) => {
              if (res.data.success) {
                setImages(res.data.data);
              }
            })
            .catch((err) => console.log(err));
        }, []);
const products = [
  {
    id: 1,
    src: images[0]?.image_url,
    alt: "Sliding Partitions",
    title: "Sliding Partitions",
    shortDescription: "Discover our exquisite range of luxury glass products.",
    relatedImages: [images[5]?.image_url, images[5]?.image_url, images[6]?.image_url],
    features: ["Innovative", "Modern", "Durable", "Elegant", "Customizable"],
  },
  {
    id: 2,
    src: images[1]?.image_url,
    alt: "Swing Partitions",
    title: "Swing Partitions",
    shortDescription: "Explore our collection of modern door designs.",
    relatedImages: [images[5]?.image_url, images[5]?.image_url, images[3]?.image_url],
    features: ["Stylish", "Functional", "Space-Saving", "Premium"],
  },
  // {
  //   id: 3,
  //   src: glass3,
  //   alt: "Flush Doors",
  //   title: "Flush Doors",
  //   shortDescription: "Stylish and functional wardrobe solutions.",
  //   relatedImages: [glass6, door, studioglassdoors],
  // },
  {
    id: 4,
    src: images[8]?.image_url,
    alt: "Bathroom & Wardrobes",
    title: "Bathroom & Wardrobes",
    shortDescription: "State-of-the-art shower enclosures for every bathroom.",
    relatedImages: [images[5]?.image_url, images[5]?.image_url, images[2]?.image_url],
    features: ["Minimalist", "Elegant Finish", "Versatile"],
  },
  {
    id: 5,
    src: images[10]?.image_url,
    alt: "Shower Enclosures",
    title: "Shower Enclosures",
    shortDescription: "Modern and elegant kitchen collections.",
    relatedImages: [images[3]?.image_url, images[7]?.image_url, images[9]?.image_url],
    features: ["Sleek", "Sturdy", "Smooth Operation"],
  },
  {
    id: 6,
    src: images[9]?.image_url,
    alt: "Led Mirrors",
    title: "Led Mirrors",
    shortDescription: "Stylish and functional wardrobe solutions.",
    relatedImages: [images[6]?.image_url, images[5]?.image_url, images[2]?.image_url],
    features: ["Innovative", "Contemporary Design", "Energy-Efficient"],
  },
];
  return (
    <Box maxW="1400px" mx="auto" px={{ base: 4, md: 8 }} pt={4} pb={16}>
      <Heading
        as="h2"
        size="xl"
        mb={12}
        textAlign="center"
        position="relative"
        // _after={{
        //   content: '""',
        //   display: "block",
        //   width: "100px",
        //   height: "4px",
        //   bg: "#6A7FDB",
        //   position: "absolute",
        //   bottom: "-10px",
        //   left: "50%",
        //   transform: "translateX(-50%)",
        //   borderRadius: "full",
        // }}
      >
        Our Products
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
        {products.map((product, index) => (
          <MotionBox
            key={product.id}
            as={Link}
            to={`/product/${product.id}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            onMouseEnter={() => setHoveredId(product.id)}
            onMouseLeave={() => setHoveredId(null)}
            bg={cardBg}
            borderRadius="xl"
            overflow="hidden"
            boxShadow="md"
            border="1px solid"
            borderColor={cardBorder}
            position="relative"
            _hover={{
              boxShadow: hoverShadow,
              transform: "translateY(-5px)",
              borderColor: "#000000",
            }}
          >
            {/* Badge for featured items (example) */}
            {index % 3 === 0 && (
              <Badge
                position="absolute"
                top={4}
                right={4}
                bg="white" 
        opacity={0.7}
                px={2}
                py={1}
                borderRadius="full"
                zIndex="1"
              >
                Popular
              </Badge>
            )}

            <Box position="relative" overflow="hidden" height="280px">
              <MotionImage
                src={product.src}
                alt={product.alt}
                width="100%"
                height="100%"
                objectFit="cover"
                transition="0.3s ease"
                whileHover={{ scale: 1.05 }}
              />

              <Box
                position="absolute"
                bottom={0}
                left={0}
                right={0}
                bgGradient="linear(to-t, rgba(0,0,0,0.8), transparent)"
                p={4}
                pt={8}
              >
                <Flex justify="space-between" align="flex-end">
                  <Box>
                    <Heading as="h3" size="md" color="white" mb={1}>
                      {product.title}
                    </Heading>
                    <Text color="whiteAlpha.800" fontSize="sm" noOfLines={1}>
                      {product.shortDescription}
                    </Text>
                  </Box>
                  <Icon
                    as={FiArrowRight}
                    color="white"
                    boxSize={5}
                    opacity={hoveredId === product.id ? 1 : 0}
                    transform={
                      hoveredId === product.id
                        ? "translateX(0)"
                        : "translateX(-10px)"
                    }
                    transition="all 0.3s ease"
                  />
                </Flex>
              </Box>
            </Box>
          
            <VStack p={5} spacing={3} align="start">
              <Flex wrap="wrap" gap={2}>
                <Wrap spacing={2}>
            {product.features.map((feature, i) => (
              <WrapItem key={i}>
                <Badge bg="black" opacity={0.5} color={"white"} variant="subtle">
                  {feature}
                </Badge>
              </WrapItem>
            ))}
          </Wrap>
                {/* <Badge colorScheme="teal" variant="subtle">
                  Modern
                </Badge>
                <Badge colorScheme="blue" variant="subtle">
                  Durable
                </Badge>
                <Badge colorScheme="purple" variant="subtle">
                  Elegant
                </Badge> */}
              </Flex>

              <Text color={textColor} noOfLines={2} fontSize="sm">
                {product.shortDescription} Click to explore more details about
                this premium product.
              </Text>

              {/* <Box
                w="100%"
                h="1px"
                bg="linear-gradient(to right, transparent, #000000, transparent)"
                my={2}
              />

              <Flex justify="space-between" w="100%" align="center">
                <Text fontSize="sm" fontWeight="semibold" color={titleColor}>
                  View Details
                </Text>
                <Box
                  w="30px"
                  h="30px"
                  borderRadius="full"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FiArrowRight} color="white" boxSize={4} />
                </Box>
              </Flex> */}
            </VStack>
          </MotionBox>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default ProductDetails;
